import _taggedTemplateLiteral from "@babel/runtime/helpers/taggedTemplateLiteral";

var _templateObject;

import { gql } from '@apollo/client';
export var TaxSummaryFragment = gql(_templateObject || (_templateObject = _taggedTemplateLiteral(["\n    fragment TaxSummaryFragment on CartPrices {\n        applied_taxes {\n            amount {\n                currency\n                value\n            }\n        }\n    }\n"])));